const ITEMS = ["Research", "Script", "Storyboard", "Narration", "Visuals", "Documentary", "pitsora"];

export default function Marquee() {
  return (
    <div
      className="overflow-hidden border-y border-white/5 bg-[#0A0A0A] py-6"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
              <span key={`${dup}-${item}`} className="flex items-center">
                <span
                  className={`font-display text-2xl font-semibold uppercase tracking-wide sm:text-3xl ${
                    item === "pitsora" ? "text-[#D4AF37]" : "text-[#2E2E2E]"
                  }`}
                >
                  {item}
                </span>
                <span className="mx-10 h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
